import { createCanvas, get2D } from './canvasUtil';

/** 程序生成的视觉纹理（木纹 / 噪点），用于桌面背景与碎片纸质质感。 */

export interface WoodOptions {
  base?: string;
  dark?: string;
  light?: string;
  graining?: number; // 纹理强度 0..1
}

/** 生成木纹纹理：基底渐变 + 波浪木纹线 + 颗粒噪点。 */
export function generateWoodTexture(w: number, h: number, opts: WoodOptions = {}): HTMLCanvasElement {
  const base = opts.base ?? '#33241a';
  const dark = opts.dark ?? '#1f150e';
  const light = opts.light ?? '#3f2e20';
  const graining = opts.graining ?? 0.55;

  const c = createCanvas(w, h);
  const ctx = get2D(c);

  const g = ctx.createLinearGradient(0, 0, 0, h);
  g.addColorStop(0, light);
  g.addColorStop(0.5, base);
  g.addColorStop(1, dark);
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, w, h);

  // 木纹长条纹（横向 sin 扰动）
  const lines = Math.max(40, Math.round((h / 100) * 18));
  for (let i = 0; i < lines; i++) {
    const y = Math.random() * h;
    const amp = 4 + Math.random() * 10;
    const freq = 0.5 + Math.random() * 2.5;
    const phase = Math.random() * Math.PI * 2;
    ctx.strokeStyle = i % 4 === 0 ? light : dark;
    ctx.globalAlpha = graining * (0.12 + Math.random() * 0.22);
    ctx.lineWidth = 0.5 + Math.random() * 1.6;
    ctx.beginPath();
    ctx.moveTo(0, y);
    for (let x = 0; x <= w; x += 10) {
      const yy = y + Math.sin((x / w) * Math.PI * 2 * freq + phase) * amp + (Math.random() - 0.5) * 2;
      ctx.lineTo(x, yy);
    }
    ctx.stroke();
  }

  // 颗粒噪点
  ctx.globalAlpha = 0.05;
  ctx.fillStyle = '#000';
  const dots = Math.round((w * h) / 260);
  for (let i = 0; i < dots; i++) {
    ctx.fillRect(Math.random() * w, Math.random() * h, 1, 1);
  }
  ctx.globalAlpha = 1;
  return c;
}

/** 生成灰度噪点纹理（用于碎片纸张质感叠加，overlay 混合）。 */
export function generateNoiseTexture(w: number, h: number, intensity = 0.08): HTMLCanvasElement {
  const c = createCanvas(w, h);
  const ctx = get2D(c);
  const img = ctx.createImageData(w, h);
  for (let i = 0; i < img.data.length; i += 4) {
    const v = 128 + (Math.random() - 0.5) * 255;
    img.data[i] = v;
    img.data[i + 1] = v;
    img.data[i + 2] = v;
    img.data[i + 3] = Math.round(Math.random() * intensity * 255);
  }
  ctx.putImageData(img, 0, 0);
  return c;
}
